import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { ADMIN_COLORS } from '@/constants/admin';

interface DesktopPanelHeaderProps {
  title: string;
  onClose: () => void;
  right?: React.ReactNode;
}

export const DesktopPanelHeader: React.FC<DesktopPanelHeaderProps> = ({ title, onClose, right }) => {
  return (
    <View style={styles.header}>
      <Text style={styles.title}>{title}</Text>
      <View style={styles.right}>
        {right}
        <TouchableOpacity onPress={onClose} style={styles.closeButton}>
          <Text style={styles.closeText}>✕</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
    paddingVertical: 14,
    borderBottomWidth: 1,
    borderBottomColor: ADMIN_COLORS.BORDER,
    backgroundColor: ADMIN_COLORS.BACKGROUND.PRIMARY,
  },
  title: {
    fontSize: 18,
    paddingHorizontal: 18,
    fontWeight: '700',
    color: ADMIN_COLORS.TEXT_PRIMARY,
  },
  right: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  closeButton: {
    paddingHorizontal: 8,
    paddingVertical: 4,
  },
  closeText: {
    fontSize: 18,
    color: ADMIN_COLORS.TEXT_SECONDARY,
  },
});


